const colours = {
  ocean: '#00639E',
};

export default colours;
